import { NumberInputSetting } from "components/settings";
import { WidgetSettingFC } from "types/Setting";

import { ColumnMapping, PlaceValueMatState } from "./PlaceValueMat";

interface Props {
  label: string;
  minValue?: number;
  maxValue?: number;
  wholeNumbers?: boolean;
}

export const PlaceValueMatNumberSetting: WidgetSettingFC<number, Props, PlaceValueMatState> = ({
  state,
  settings,
  ...props
}) => {
  const decimalCount = ColumnMapping[settings.decimals];
  const currentValue = Number(state.values.join("")) / Math.pow(10, decimalCount);
  const softMax = Math.pow(10, ColumnMapping[settings.cols]) - Math.pow(0.1, decimalCount);

  return (
    <NumberInputSetting
      state={state}
      settings={settings}
      {...props}
      info={{ ...props.info, value: currentValue, maxValue: softMax }}
    />
  );
};
